/**
 * Valencia EWS — cart qty / remove auto-sync.
 *
 * Strategy: own +/- and Remove, POST /cart/change.js, then reload /cart.
 * Full reload is what "Update Cart" did — prices (WPD set price + retail 5%)
 * always come from Liquid/SSR. Avoids DOM race storms (11→4, stale totals).
 *
 * Cart page only (ajax_disable=true).
 */
(function () {
  if (window.__vpCartAutoUpdateInit) return;
  window.__vpCartAutoUpdateInit = true;

  var root = document.querySelector('[data-section-type="cart"][data-ajax-disable="true"]');
  if (!root) return;

  try {
    window.wpd_bypass_quantity_reload = true;
  } catch (e) {}

  var debounceTimer = null;
  var syncSeq = 0;
  var inflight = false;
  var pendingChange = null;
  var reloadArmed = false;

  var form =
    root.querySelector('form.cart') ||
    root.closest('form') ||
    document.querySelector('[data-section-type="cart"] form.cart');

  if (form) {
    form.addEventListener(
      'submit',
      function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.getAttribute('name') === 'checkout') return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  }

  function cartPageUrl() {
    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    try {
      var preview =
        new URLSearchParams(window.location.search).get('preview_theme_id') ||
        sessionStorage.getItem('vp_preview_theme_id');
      if (preview) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + encodeURIComponent(preview);
      }
    } catch (e) {}
    return url;
  }

  function reloadCart() {
    window.location.href = cartPageUrl();
  }

  function money(cents) {
    var n = Number(cents);
    if (isNaN(n)) n = 0;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(n, (window.theme && theme.moneyFormat) || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (n / 100).toFixed(2);
  }

  function parseMoney(text) {
    if (text == null) return 0;
    var s = String(text).replace(/[^0-9.]/g, '');
    if (!s) return 0;
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function unitForRow(row, key) {
    if (window.__vpMayoristaUnitLock && key && window.__vpMayoristaUnitLock[key]) {
      return window.__vpMayoristaUnitLock[key];
    }
    var unitEl =
      row.querySelector('[data-vp-unit-price]') ||
      row.querySelector('.cart__items__price [data-cart-item-price]');
    return unitEl ? parseMoney(unitEl.textContent) : 0;
  }

  /** Instant line/subtotal feedback while waiting for reload */
  function paintLiveTotals() {
    var sum = 0;
    root.querySelectorAll('.cart__items__row').forEach(function (row) {
      var input = row.querySelector('[data-update-cart]');
      if (!input) return;
      var key = input.getAttribute('data-update-cart') || '';
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var unit = unitForRow(row, key);
      var lineEl = row.querySelector('[data-vp-line-price], [data-wpd-cart-line-price]');
      if (unit > 0) {
        if (lineEl) lineEl.textContent = money(unit * qty);
        sum += unit * qty;
      }
    });
    if (sum >= 0) {
      root.querySelectorAll('.wcp-cart-total, [data-wpd-cart-total]').forEach(function (el) {
        el.textContent = money(sum);
      });
    }
  }

  function postChange(key, qty, rowToRemove) {
    if (!key || isNaN(qty) || qty < 0) return;

    if (inflight) {
      pendingChange = { key: key, qty: qty, rowToRemove: rowToRemove || null };
      syncSeq++;
      return;
    }

    var mySeq = ++syncSeq;
    inflight = true;
    root.classList.add('vp-cart-syncing');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function (cart) {
        if (mySeq !== syncSeq) return;
        if (qty === 0 && rowToRemove) rowToRemove.remove();
        paintLiveTotals();
        reloadArmed = true;
        try {
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } })
          );
        } catch (e) {}
      })
      .catch(function () {
        if (mySeq !== syncSeq) return;
        reloadArmed = true;
      })
      .finally(function () {
        inflight = false;
        root.classList.remove('vp-cart-syncing');
        if (pendingChange) {
          var next = pendingChange;
          pendingChange = null;
          postChange(next.key, next.qty, next.rowToRemove);
          return;
        }
        if (reloadArmed) {
          reloadArmed = false;
          reloadCart();
        }
      });
  }

  function scheduleFromInput(input) {
    if (!input || !input.getAttribute('data-update-cart')) return;
    if (!root.contains(input)) return;
    var key = input.getAttribute('data-update-cart');
    var qty = parseInt(input.value, 10);
    input.setAttribute('value', String(isNaN(qty) ? 0 : qty));
    paintLiveTotals();
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      postChange(key, qty, qty === 0 ? input.closest('.cart__items__row') : null);
    }, 280);
  }

  root.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.getAttribute || !t.getAttribute('data-update-cart')) return;
      scheduleFromInput(t);
    },
    true
  );

  root.addEventListener(
    'input',
    function (e) {
      var t = e.target;
      if (!t || !t.getAttribute || !t.getAttribute('data-update-cart')) return;
      paintLiveTotals();
    },
    true
  );

  root.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      var remove = e.target.closest(
        'button[data-remove-key], a[data-remove-key], a[href*="/cart/change"][href*="quantity=0"]'
      );
      if (remove && root.contains(remove)) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var key =
          remove.getAttribute('data-remove-key') ||
          (function () {
            var row = remove.closest('.cart__items__row');
            var input = row && row.querySelector('[data-update-cart]');
            return input ? input.getAttribute('data-update-cart') : '';
          })();
        var row = remove.closest('.cart__items__row');
        if (key) postChange(key, 0, row);
        return;
      }

      var btn = e.target.closest('[data-increase-quantity], [data-decrease-quantity]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      var wrap = btn.closest('[data-quantity-selector], .quantity__wrapper, .cart__items__quantity');
      var input = wrap && wrap.querySelector('[data-update-cart]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 0;
      if (btn.hasAttribute('data-increase-quantity')) v += 1;
      else v = Math.max(0, v - 1);
      input.value = v;
      input.setAttribute('value', String(v));
      scheduleFromInput(input);
    },
    true
  );
})();
